// extracted by mini-css-extract-plugin
export var grid = "Grid-module--grid--chfBJ";